import PropTypes from 'prop-types';
import React from 'react';
import { createStyles } from 'app/utils/css';

export default function ModalContent({ children }) {
  return (
    <Styles>{css =>
      <div className={css('modalContent')}>{children}</div>
    }</Styles>
  );
}

ModalContent.propTypes = {
  children: PropTypes.node,
};

const Styles = createStyles({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: '1em',
  },
});
